export default "__VITE_ASSET__Bdr8OoH4__"